import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const client = axios.create({ baseURL: API_URL });
export const weatherApi = {
  getCurrent: (city) => client.get(`/weather/current?q=${encodeURIComponent(city)}`),
  getForecast: (city) => client.get(`/weather/forecast?q=${encodeURIComponent(city)}`)
};
export default client;
